<div class="modal-header">
  <h4 *ngIf="create" class="modal-title" id="modal-basic-title" translate>ADD_NEW_CUSTOMER</h4>
  <h4 *ngIf="!create" class="modal-title" id="modal-basic-title" translate>EDIT_CUSTOMER</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
    [disabled]="isSubmitted ? true : null"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form class="form" [formGroup]="customerForm">
    <div *ngIf="create || isAdminCapstone || isSalesCapstone" class="" [formGroupName]="'extra'">
      <lib-gung-tabset [destroyOnHide]="false">
        <!-- DELIVERY_PLUS_ADDRESS -->
        <lib-gung-tab [title]="'DELIVERY_PLUS_ADDRESS' | translate">
          <ng-template libGungTabContent>
            <div class="form-row pt-2">
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'fr'">
                  <lib-gung-text-input [gungTranslate]="'FR_FTGNAMN'" formControlName="ftgnamn" ngbAutofocus>
                  </lib-gung-text-input>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'fr'">
                  <lib-gung-text-input [gungTranslate]="'FR_FTGPOSTADR1'" formControlName="ftgpostadr1">
                  </lib-gung-text-input>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'fr'">
                  <lib-gung-text-input [gungTranslate]="'FR_FTGPOSTADR2'" formControlName="ftgpostadr2">
                  </lib-gung-text-input>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'fr'">
                  <lib-gung-text-input [gungTranslate]="'FR_FTGPOSTADR5'" formControlName="ftgpostadr5">
                  </lib-gung-text-input>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'fr'">
                  <lib-gung-text-input [gungTranslate]="'FR_FTGPOSTNR'" formControlName="ftgpostnr">
                  </lib-gung-text-input>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'fr'">
                  <lib-gung-text-input [gungTranslate]="'FR_FTGLEVPOSTNR'" formControlName="ftglevpostnr">
                  </lib-gung-text-input>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'fr'">
                  <lib-gung-text-input [gungTranslate]="'FR_FTGPOSTADR3'" formControlName="ftgpostadr3">
                  </lib-gung-text-input>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'fr'">
                  <lib-gung-text-input [gungTranslate]="'FR_FTGPOSTLEVADR3'" formControlName="ftgpostlevadr3">
                  </lib-gung-text-input>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'fr'">
                  <lib-meta-select-input formControlName="landskod" table="xr" metaId="landskod" metaDisplay="land">
                  </lib-meta-select-input>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'fr'">
                  <lib-gung-text-input [gungTranslate]="'ORG_NR'" formControlName="orgnr" [renderStatic]="!create"> </lib-gung-text-input>
                </div>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
        <!-- CONDITIONS -->
        <lib-gung-tab *ngIf="!isSalesCapstone || (isSalesCapstone && create)">
          <ng-template libGungTabTitle><span translate>CONDITIONS</span></ng-template>
          <ng-template libGungTabContent>
            <div class="form-row pt-2">
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'kus'">
                  <lib-meta-select-input
                    formControlName="levvillkkod"
                    table="x2e"
                    metaId="levvillkkod"
                    metaDisplay="levvillkbeskr"
                  >
                  </lib-meta-select-input>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'kus'">
                  <lib-meta-select-input
                    formControlName="betkod"
                    table="x2"
                    metaId="betkod"
                    [optionsFilterFunction]="filterPaymentTerms.bind(this)"
                    metaDisplay="betvillbeskr"
                    [renderStatic]="!create"
                  >
                  </lib-meta-select-input>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'kus'">
                  <lib-meta-select-input
                    formControlName="levsattkod"
                    table="x2f"
                    metaId="levsattkod"
                    metaDisplay="levsattbeskr"
                  >
                  </lib-meta-select-input>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'kus'">
                  <lib-meta-select-input
                    formControlName="kundkategorikod"
                    table="x1k"
                    metaId="kundkategorikod"
                    [optionsFilterFunction]="filterCustomerCategories.bind(this)"
                    metaDisplay="kundkatbeskr"
                  >
                  </lib-meta-select-input>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'kus'">
                  <lib-meta-select-input
                    formControlName="saljare"
                    table="salj"
                    metaId="saljare"
                    metaDisplay="saljarenamn"
                  >
                  </lib-meta-select-input>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'kus'">
                  <lib-meta-select-input
                    formControlName="prislista"
                    table="prh"
                    metaId="prislista"
                    metaDisplay="prislistabeskr"
                  >
                  </lib-meta-select-input>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'kus'">
                  <lib-meta-select-input formControlName="valkod" table="xx" metaId="valkod" metaDisplay="valkod">
                  </lib-meta-select-input>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'kus'">
                  <lib-meta-select-input
                    formControlName="momskod"
                    table="x1"
                    metaId="momskod"
                    metaDisplay="momsbeskrivning"
                  >
                  </lib-meta-select-input>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'kus'">
                  <label class="w-100" for="kundrabattId" translate>KUS_KUNDRABATT</label>
                  <input
                    class="form-control"
                    type="number"
                    id="kundrabattId"
                    name="kundrabatt"
                    min="0"
                    max="100"
                    formControlName="kundrabatt"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6" *ngIf="isCapstone">
                <div class="form-group" [formGroupName]="'kus'">
                  <label for="kus.kundklass" translate>REF_KUNDKLASS</label>
                  <lib-meta-select-input
                    [suppressLabel]="true"
                    formControlName="kundklass"
                    table="x1kk"
                    metaId="kundklass"
                    metaDisplay="kundklassbeskr"
                  >
                  </lib-meta-select-input>
                </div>
              </div>
              <!--</div> -->
            </div>
          </ng-template>
        </lib-gung-tab>
        <!-- PRIMARY_CONTACT -->
        <lib-gung-tab *ngIf="create || isAdminCapstone || isSalesCapstone" [title]="'CONTACT' | translate">          
          <ng-template libGungTabContent>
            <!-- <div class="form-row pt-2">
              <div class="col-12 col-md-6">
                <div [formGroupName]="'kus'" class="form-group">
                  <lib-gung-text-input [gungTranslate]="'EMAIL'" formControlName="q_email_invoice">
                  </lib-gung-text-input>
                </div>
              </div>
            </div> -->
            <div class="form-row">
              <div class="col-12 col-md-6">
                <div class="">
                  <div [formGroupName]="'fr'" class="form-group">
                    <lib-gung-text-input [gungTranslate]="'PHONE'" formControlName="comnr"> </lib-gung-text-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-6">
                <div class="">
                  <div [formGroupName]="'kus'" class="form-group">
                    <lib-gung-text-input [gungTranslate]="'INVOICE_EMAIL_ADDRESS'" formControlName="q_email_invoice"> </lib-gung-text-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-6">
                <div class="">
                  <div [formGroupName]="'fr'" class="form-group">
                    <lib-gung-text-input [gungTranslate]="'MARKTING_EMAIL'" formControlName="wemailaddress"> </lib-gung-text-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row" *ngIf="!create && isSalesCapstone">
              <div class="col-12 col-md-6">
                <div class="">
                  <div [formGroupName]="'kus'" class="form-group">
                    <label class="control-label" for="kundrabatt" translate>KUS_KUNDRABATT</label>
                    <input
                      class="form-control"
                      name="kundrabatt"
                      type="number"
                      formControlName="kundrabatt"
                      step="0.01"
                      value="0.00"
                      placeholder="0.00"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row" *ngIf="!create && isSalesCapstone">
              <div class="col-12 col-md-6">
                <div [formGroupName]="'kus'" class="">
                  <div class="form-group">
                    <label for="kus.kundklass" translate>REF_KUNDKLASS</label>
                    <lib-meta-select-input
                      [suppressLabel]="true"
                      formControlName="kundklass"
                      table="x1kk"
                      metaId="kundklass"
                      metaDisplay="kundklassbeskr"
                    >
                    </lib-meta-select-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row" *ngIf="!create && isSalesCapstone">
              <div class="col-12 col-md-6">
                <div class="form-group" [formGroupName]="'kus'">
                  <lib-meta-select-input
                    formControlName="kundkategorikod"
                    table="x1k"
                    metaId="kundkategorikod"
                    [optionsFilterFunction]="filterCustomerCategories.bind(this)"
                    metaDisplay="kundkatbeskr"
                  >
                  </lib-meta-select-input>
                </div>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
      </lib-gung-tabset>
    </div>
    <div *ngIf="!create && !isAdminCapstone && !isSalesCapstone" [formGroupName]="'extra'">
      <div [formGroupName]="'kus'" class="">
        <lib-gung-text-input [gungTranslate]="'EMAIL'" formControlName="q_email_invoice" ngbAutofocus>
        </lib-gung-text-input>
        <div
          *ngIf="
            customerForm.get('extra.kus.q_email_invoice').invalid &&
            (customerForm.get('extra.kus.q_email_invoice').dirty ||
              customerForm.get('extra.kus.q_email_invoice').touched) &&
            customerForm.get('extra.kus.q_email_invoice').errors.email
          "
          class="alert alert-danger"
        >
          <span translate>NOT_VALID_EMAIL</span>!
        </div>
      </div>
      <div [formGroupName]="'fr'" class="">
        <lib-gung-text-input [gungTranslate]="'PHONE'" formControlName="comnr"></lib-gung-text-input>
      </div>
      <div [formGroupName]="'kus'" class="">
        <div class="form-group">
          <label class="control-label" for="kundrabatt" translate>KUS_KUNDRABATT</label>
          <input
            class="form-control"
            name="kundrabatt"
            type="number"
            formControlName="kundrabatt"
            step="0.01"
            value="0.00"
            placeholder="0.00"
          />
        </div>
      </div>
      <div class="form-group" [formGroupName]="'fr'">
        <lib-gung-text-input [gungTranslate]="'ORG_NR'" formControlName="orgnr" [renderStatic]="true"> </lib-gung-text-input>
      </div>
      <div [formGroupName]="'kus'" class="" *ngIf="isCapstone">
        <div class="form-group">
          <label for="kus.kundklass" translate>REF_KUNDKLASS</label>
          <lib-meta-select-input
            [suppressLabel]="true"
            formControlName="kundklass"
            table="x1kk"
            metaId="kundklass"
            metaDisplay="kundklassbeskr"
          >
          </lib-meta-select-input>
        </div>
      </div>
    </div>
  </form>
  <ngb-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message | translate }}</ngb-alert>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-light mr-auto"
    aria-label="Close"
    (click)="activeModal.close()"
    [disabled]="isSubmitted ? true : null"
    translate
  >
    CANCEL
  </button>
  <button
    *ngIf="create"
    type="button"
    class="btn btn-primary ml-auto"
    (click)="submitForm()"
    [disabled]="isSubmitted ? true : null"
    translate
  >
    CREATE_CUSTOMER <span><i *ngIf="isSubmitted" class="fas fa-spinner fa-spin"></i></span>
  </button>
  <button
    *ngIf="!create"
    type="button"
    type="button"
    class="btn btn-primary ml-auto"
    (click)="submitForm()"
    [disabled]="isSubmitted ? true : null"
    translate
  >
    UPDATE_CUSTOMER <i *ngIf="isSubmitted" class="fas fa-spinner fa-spin"></i>
  </button>
</div>
